import { SxProps } from '@mui/system';
import { Box, Grid, IconButton, styled, Theme } from '@mui/material';

import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { faPencil } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { ReactComponent as FourDots } from '../icons/FourDots.svg';
import { CerebroIconButton } from '.';

interface CerebroComplexListItemProps
	extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
	sx?: SxProps<Theme>;

	onEdit?: () => void;

	onDelete?: () => void;
	onDeleteTitle?: string;
	showDelete?: boolean;

	tags?: string[];
}

export const CerebroComplexListItem: React.FC<CerebroComplexListItemProps> = ({
	onEdit,

	onDelete,
	onDeleteTitle,
	showDelete,

	children,

	tags,

	...props
}) => {
	return (
		<Wrapper {...props}>
			<Toolbar>
				<Box sx={{ display: 'flex', alignItems: 'center' }}>
					<FourDots />

					{tags !== undefined && tags.map((tag, index) => <Tag key={`${tag}-${index}`}>{tag}</Tag>)}
				</Box>
				<div>
					{onEdit && (
						<IconButton sx={theme => ({ color: theme.palette.gray.dark })} onClick={onEdit}>
							<FontAwesomeIcon icon={faPencil} size="sm" />
						</IconButton>
					)}
					{showDelete && onDelete && (
						<CerebroIconButton color="error" onClick={onDelete} title={onDeleteTitle}>
							<FontAwesomeIcon icon={faTrash} size="sm" />
						</CerebroIconButton>
					)}
				</div>
			</Toolbar>
			{children}
		</Wrapper>
	);
};

const Wrapper = styled('div')(({ theme }) => ({
	backgroundColor: theme.palette.common.white,

	borderWidth: 1,
	borderStyle: 'solid',
	borderColor: theme.palette.gray.medium,
	borderRadius: theme.shape.borderRadius,

	boxShadow: theme.shadows[3],

	padding: theme.spacing(3),
}));

const Toolbar = styled('div')(({ theme }) => ({
	display: 'flex',
	justifyContent: 'space-between',

	marginBottom: theme.spacing(3),
}));

const Tag = styled('p')(({ theme }) => ({
	backgroundColor: theme.palette.primary.light,
	borderRadius: 30,

	margin: 0,
	marginLeft: theme.spacing(2),
	padding: theme.spacing(0.5, 1),

	...theme.typography.hint,
	fontSize: 10,
}));
